import axios from "axios";
import { HOST } from "./host";
export const getReportList = async () => {
  const response = await axios.get(`https://${HOST}/campaign/report`);
  return response.data;
};
